import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCaseNegotiations(token, caseId, query) {
    const q = buildQuery(query);
    return axios.get(`${baseUrl}/case/${caseId}/negotiations${q}`, {
        headers: {
            authorization: token
        }
    })
}

export function addNewNegotiation (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation`, data, {
        headers: {
            authorization: token
        }
    })
}

export function getNegotiationDetails (token, caseId, negId) {
    return axios.get(`${baseUrl}/case/${caseId}/negotiation-details/${negId}`, {
        headers: {
            authorization: token
        }
    })
}

export function addNegotiationDetails (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation-detail`, data, {
        headers: {
            authorization: token
        }
    })
}

export function confirmNegotiation (token, caseId, negId) {
    return axios.patch(`${baseUrl}/case/${caseId}/negotiation/${negId}/confirm`, {}, {
        headers: {
            authorization: token
        }
    })
}